
function KidsEn() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/playground_banner.jpg" alt="playground" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>With kit and caboodle</h1>
                            <p>Wismar has a lot to offer younger children. When all the buildings, streets and beaches 
                                have been inspected by the grown-ups and the umpteenth sandcastle has been built, it's 
                                finally time for learning, playing and romping fun.
                            </p>
                        </div>
                        <div className="text">
                            <h2>phanTECHNIKUM</h2>
                            <p>For all those who want to immerse themselves in the exciting world of machines, vehicles 
                                and all kinds of non-digital technology. To marvel at, touch and join in. Have you ever 
                                seen what a ship's engine weighing several tonnes looks like? Or bicycles 100 years ago? 
                                Did you know that the first ejection seat for pilots was invented in the federal state of
                                Mecklenburg Vorpommern? These and many other exciting things can be marvelled at in the 
                                phanTECHNIKUM.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Indoor play park</h2>
                            <p>Children of all ages can really let off steam here, especially when the weather isn't great. 
                                There are two indoor play parks in Wismar: Mumpitz and Wonniland. With lots of activity 
                                stations to keep everyone moving.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Pirate tour</h2>
                            <p>The boat tour with entertainment on board. In real pirate clothing and everything that makes 
                                up a pirate adventure on the high seas. Definitely not as boring as just looking at houses 
                                and water with the adults.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wonnemar</h2>
                            <p>Swimming, splashing around, having fun. Beach too crowded or weather too rainy? Water lovers 
                                of all ages will get their money's worth at the adventure pool. Not only children can let off 
                                steam here, but adults can also spend a relaxing day in the sauna or spa.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Kindermotorland</h2>
                            <p>The Wohlenberger Wiek is a fast-paced place. The Kindermotorland is the place for lots of 
                                action and speed fun. From March to October, kids aged 7 and over can do their laps on 
                                motorbikes or in buggies.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default KidsEn;